export const DAILY_RENT_OTA_CONVERSION = 'dailyrent_web_sut375_online_booking_cr';
export const MOBWEB_ABC_ACTION_BUTTTON = 'dailyrent_mobile_pdsc96_new_listing_buttons';
export const AUD_MOBWEB_AUD222_PERETOKI = 'aud_mobweb_aud222_peretoki';
export const MOBWEB_PRICE_FILTER = 'dailyrent_mobile_daily189_price_filter';
export const DAILYRENT_DESKTOP_HYBRID_EXP = 'dailyrent_desktop_daily67_hybrid_listing';
export const AUD_WEB_BX1122_PIN_UNIFICATION = 'aud_web_bx1122_pin_unification';

export const EXPERIMENTS: string[] = [
  DAILY_RENT_OTA_CONVERSION,
  MOBWEB_ABC_ACTION_BUTTTON,
  AUD_MOBWEB_AUD222_PERETOKI,
  MOBWEB_PRICE_FILTER,
  DAILYRENT_DESKTOP_HYBRID_EXP,
  AUD_WEB_BX1122_PIN_UNIFICATION,
];
